import {Grid2 as Grid, useTheme} from "@mui/material";
import {Link2} from "../../../domains/common/components/Typography";
import Box from "@mui/material/Box";
import {ButtonBase} from "../../../domains/common/components/Button";
import {Add, HelpOutline} from "@mui/icons-material";
import {SettingsButton, SettingsDrawer} from "../../../domains/common/components/Settings";
import {LogOut} from "../../../domains/common/components/Head";
import React from "react";
import {FindDealComponent} from "./find";

export const DealsHeader = () => {
  const [settingsDrawer, openDrawer, closeDrawer] = SettingsDrawer({closeOnBackdrop: true})

  const openSettings = () => {
    openDrawer()
  }

  const theme = useTheme();

  return (
    <>
      {settingsDrawer}
      <Grid container spacing={0} wrap="nowrap">
        <Grid size={{xs: 0, sm: 0, md: 0, lg: 1.5}}/>
        <Grid size={{xs: 6, sm: 6, md: 1, lg: 1}}
              sx={{lineHeight: '50px', paddingLeft: {xs: '10px', sm: '10px', md: '10px', lg: '0px'}}}
              minWidth="125px">
          <NewDealButton></NewDealButton>
        </Grid>
        <Grid size={{xs: 6, sm: 6, md: 1, lg: 1}} sx={{paddingTop: '3px', lineHeight: '50px', paddingLeft: '20px'}}
              minWidth="95px">
          <Link2 href="/clients" color="text.secondary">Клиенты</Link2>
        </Grid>
        <Grid size={{xs: 12, sm: 12, md: 7, lg: 7, xl: 7}}
              sx={{lineHeight: '50px', alignItems: 'center', minWidth: '300px'}}
              display="flex" justifyContent="flex-end">
          <FindDealComponent />
        </Grid>
        <Grid size={{xs: 12, sm: 12, md: 2.5, lg: 1.5}} sx={{minWidth: '150px'}}>
          <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-end">
            <ButtonBase href="https://kb.esoft.tech/doc/elektronnaya-registraciya-seva-l47rAJOiA9" target="_blank"
                        variant="text" sx={{color: theme.palette.icon.default}}>
              <HelpOutline/>
            </ButtonBase>
            <SettingsButton onClick={openSettings}/>
            <LogOut/>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export function NewDealButton() {
  return (
    <a href="/deal"><ButtonBase variant="contained" sx={{fontSize: '14px'}} size="medium" color="info" startIcon={<Add/>}>Создать</ButtonBase></a>
  )
}
